import { useTranslation } from 'react-i18next'
import { Grid, Paper, Typography } from '@mui/material'
import { Dropdown } from '@carsys/ui'
import EnvironmentFeature, { EnvironmentSimulator } from 'utils-support/EnvironmentFeature'
import { ROLES_OPTIONS } from 'core/constants/roles'
import { OPERATING_UNIT } from 'core/constants/operatingunit'
import { SupportEnvironment } from 'core/enums/enums'
import { changeUserOperatingUnit, changeUserRole } from './auth/state/actions'
import { useDispatch, useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { Appid, Operatingunit } from '@cbgms/api'

const AccountSettings = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const role = useSelector((state: IRootReducerState) => state.auth.user['custom:role'])
  const operatingunit = useSelector((state: IRootReducerState) => state.auth.user['ou_name'])
  const appid = useSelector((state: IRootReducerState) => state.auth.user['AppId'] || Appid.ModelOuAppId)
  const handleChoice = (value: any) => {
    dispatch(changeUserRole(value))
  }

  const handleOperatingUnitChoice = (value: Operatingunit, appid: Appid) => {
    if (value === Operatingunit.ModelOu) {
      appid = Appid.ModelOuAppId
    } else if (value === Operatingunit.PVOu) {
      appid = Appid.PVOuAppId
    } else {
      appid = Appid.StakisOuAppId
    }
    dispatch(changeUserOperatingUnit(value, appid))
  }

  return (
    <Grid container spacing={1}>
      <EnvironmentFeature environments={SupportEnvironment.Develop} ignoreSimulatedEnvironment>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant='h4' sx={{ pb: 1 }}>
              Developer settings
            </Typography>
            <EnvironmentSimulator />
          </Paper>
        </Grid>
      </EnvironmentFeature>
      <EnvironmentFeature environments={SupportEnvironment.Develop}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant='h4' sx={{ pb: 1 }}>
              {t('global.roles_and_rights')}
            </Typography>
            <Dropdown
              placeholder={t('global.select_role')}
              data-testid='dropdown-role-change'
              label={t('global.account_settings')}
              onChange={e => handleChoice(e.target.value)}
              options={ROLES_OPTIONS}
              value={role}
            />
          </Paper>
        </Grid>
      </EnvironmentFeature>
      <EnvironmentFeature environments={SupportEnvironment.Develop}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography variant='h4' sx={{ pb: 1 }}>
              {t('global.operating_unit')}
            </Typography>
            <Dropdown
              placeholder={t('global.select_operating_unit')}
              data-testid='dropdown-ou-change'
              label={t('global.operating_unit_setting')}
              onChange={e => handleOperatingUnitChoice(e.target.value as Operatingunit, appid as Appid)}
              options={OPERATING_UNIT}
              value={operatingunit}
            />
          </Paper>
        </Grid>
      </EnvironmentFeature>
    </Grid>
  )
}

export default AccountSettings
